/**
 * @description CMDB cmdb
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '@/logic/logic-base'
import ExportTable from '@/utils/exportTable'

const cmdbBiz = new Logic()

cmdbBiz.appServerCache = null

/**
 * Created by huangzhijie on 2018/10/19.
 * 获取所有应用服务并缓存
 * @returns {Promise}
 */
cmdbBiz.getAppList = function () {
  return new Promise(function (resolve, reject) {
    if (cmdbBiz.appServerCache !== null) {
      resolve(cmdbBiz.appServerCache)
    } else {
      cmdbBiz._getAppByGroup('').then((d) => {
        try {
          const data = {}
          d.map((item) => {
            if (data[item.group] === undefined) {
              data[item.group] = {}
            }
            data[item.group][item.appName] = item.appName
          })
          cmdbBiz.appServerCache = data
          resolve(data)
        } catch (err) {
          reject(err)
        }
      }).catch((err) => {
        reject(err)
      })
    }
  })
}
/**
 * Created by huangzhijie on 2018/10/19.
 * 根据组获取应用服务（带缓存）
 * @returns {Promise}
 */
cmdbBiz.getAppByGroup = function (group) {
  return new Promise(function (resolve, reject) {
    cmdbBiz.getAppList().then((d) => {
      if (group === undefined || group === '') {
        let res = {}
        for (const key in d) {
          res = Object.assign(res, d[key])
        }
        resolve(res)
      } else {
        resolve(d[group])
      }
    }).catch((err) => {
      reject(err)
    })
  })
}
/**
 * Created by huangzhijie on 2018/10/19.
 * 根据组获取应用服务
 * @param group 组
 * @returns {Promise}
 */
cmdbBiz._getAppByGroup = function (group) {
  return this.ajax({
    ...this.REQUEST_OPT.appServer.getByGroup,
    data: {
      group: group
    }
  })
}

cmdbBiz.addSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.addSite,
    data: data
  })
}

cmdbBiz.updateSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.updateSite,
    data: data
  })
}

cmdbBiz.deleteSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.deleteSite,
    data: data
  })
}

cmdbBiz.siteList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.siteList,
    data: data
  })
}

cmdbBiz.allSite = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.allSite,
    data: data
  })
}

cmdbBiz.siteNameList = function (data) {
  return new Promise((resolve, reject) => {
    this.ajax({
      ...this.REQUEST_OPT.cmdb.siteNameList,
      data: data
    }).then((d) => {
      try {
        const data = {}
        d.map((item) => {
          data[item.code] = item.name
        })
        resolve(data)
      } catch (err) {
        reject(err)
      }
    }, function (d) {
      reject(d)
    })
  })
}

cmdbBiz.hostList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.hostList,
    data: data
  })
}

cmdbBiz.ipList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.ipList,
    data: data
  })
}

cmdbBiz.addHost = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.addHost,
    data: data
  })
}

cmdbBiz.updateHost = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.updateHost,
    data: data
  })
}

cmdbBiz.deleteHost = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.deleteHost,
    data: data
  })
}

cmdbBiz.monitorList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.monitorList,
    data: data
  })
}

cmdbBiz.monitorListByIp = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.monitorListByIp,
    data: data
  })
}

cmdbBiz.hostAwsAync = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.hostAwsAync,
    data: data
  })
}

cmdbBiz.getHostDetails = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.getHostDetails,
    data: data
  })
}

cmdbBiz.getAllSiteGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.cmdb.getAllSiteGroup,
    data: data
  })
}
/**
 * Created by huangzhijie on 2018/10/24.
 * 导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
cmdbBiz.exportHostList = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.cmdb.hostList,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    string: ['applications', 'group']
  })

  exportTable.send(success, fail)
}

export default cmdbBiz
